// extracted by mini-css-extract-plugin
export var animating = "_2i-3";
export var background = "_2i-6";
export var constrainHeight = "_2i-2";
export var dark = "_2i-4";
export var dropdown = "_2i-1";
export var leave = "_2i-5";
export var option = "_2i-7";
export var root = "_2i-0";